export const HYDRATE_ENGINE_MODELS = "HYDRATE_ENGINE_MODELS";
export const HYDRATE_ENGINE_MODELS_PENDING = "HYDRATE_ENGINE_MODELS_PENDING";
export const HYDRATE_ENGINE_MODELS_FULFILLED = "HYDRATE_ENGINE_MODELS_FULFILLED";
export const HYDRATE_ENGINE_MODELS_REJECTED = "HYDRATE_ENGINE_MODELS_REJECTED";

export const SELECT_ENGINE_MODEL = "SELECT_ENGINE_MODEL";

export const RESET_ENGINE_MODELS = "RESET_ENGINE_MODELS";
